import { Instance, types as t } from 'mobx-state-tree';
import { DragOut } from '../../../question-data-model/Question/_implementations/drag-out.store';
import { TestQuestionStore } from '../test-question.store';

export const DoTestDragOutQuestion = t
  .compose(TestQuestionStore, DragOut)
  .named('DoTestDragOutQuestion')
  .preProcessSnapshot((snap) => {
    if (snap?.userAnswers?.length === 0) {
      return { ...snap, userAnswers: (snap?.questions || []).map((_) => null) };
    }
    return snap;
  })
  .props({
    userAnswers: t.array(t.maybeNull(t.number)),
  })
  .actions((self) => ({
    answer(idx: number, spotIdx: number) {
      self.userAnswers[idx] = spotIdx;
    },
    removeAnswerByIndex(idx: number) {
      self.userAnswers[idx] = null;
    },
  }))
  .views((self) => {
    const isAnswered = (answer: number) => {
      return answer !== null;
    };

    return {
      get groupName() {
        return 'Drag Out';
      },

      get formattedQuestionNo() {
        return self.no;
      },

      get bottomBarQuestionNoes() {
        return self.questions
          .map((_, idx) => {
            const no = self.no + idx;
            return {
              no,
              answered: isAnswered(self.userAnswers[idx]),
            };
          })
          .filter((item) => Boolean(item));
      },

      get questionCount() {
        return self.questions.length;
      },

      get answerCount() {
        return self.userAnswers.filter((o) => isAnswered(o)).length;
      },

      prepareDataForSubmit() {
        return {
          questionId: self.uuid,
          type: self.type as any,
          userAnswers: self.userAnswers,
        };
      },
    };
  });

export interface DoTestDragOutInstance extends Instance<typeof DoTestDragOutQuestion> {}
